<template>
  <div class="flex w-full min-w-[120px] flex-col items-start gap-y-4 py-4">
    <div v-for="result in modelValue" :key="result.id" class="space-y-2">
      <span class="flex h-[34px] items-center justify-center">
        <lf-pill
          scorecard
          size="sm"
          class="font-semibold uppercase"
          :color-index="getColorId(result.score_card_status?.color || '')"
        >
          <span class="break-word">
            {{ result.score_card_status?.name || "-" }}
          </span>
        </lf-pill>
      </span>
    </div>
    <lf-badge v-if="!modelValue?.length" is-rounded class="font-semibold">
      <span class="px-4">-</span>
    </lf-badge>
  </div>
</template>
<script setup lang="ts">
import { getColorId } from "@/helpers/scorecards";

import LfBadge from "@/components/ui/LfBadge.vue";

import type { IScorecardResult } from "@/models/scorecards";
import type { PropType } from "vue";

defineProps({
  modelValue: {
    type: Array as PropType<IScorecardResult[]>,
  },
});
</script>
